define('modules/lp_info/views/variant_list',['require','exports','module','base/collectionview','underscore','lib/util','backbone','./variant_line','common/views/alert_view','ldsh!../templates/variant_list'],function(require, exports, module) {
  "use strict";

  var CollectionView = require("base/collectionview"),
      _ = require("underscore"),
      util = require("lib/util"),
      Backbone = require("backbone"),
      VariantLine = require("./variant_line"),
      AlertView = require("common/views/alert_view");

  var Controller = {
    duplicateVariant: function(itemView, nop, variant) {
      this.collection.duplicateVariant(variant);
    },

    copyVariantTo: function(itemView, variant, pageId) {
      this.collection.copyVariantTo(variant, pageId);
    },

    discardVariant: function(itemView) {
      var isMain = itemView.model.get("is_main");
      if (isMain && this.collection.where({ is_main: true }).length === 1) {
        AlertView.showAlert({
          message: $.i18n.t("landingPage.discardSinglePlatformError"),
          alertType: "danger"
        });
      } else if (isMain && itemView.model.get("weight") !== 100) {
        AlertView.showAlert({
          message: $.i18n.t("landingPage.discardActiveVariantsError"),
          alertType: "danger"
        });
      } else {
        this.collection.discardVariant(itemView.model);
      }
    },

    reactivateVariant: function(itemView) {
      this.collection.reactivateVariant(itemView.model);
    },

    setWeight: function(itemView, variant, weight) {
      var savingAlert = AlertView.showAlert({
        message: $.i18n.t("landingPage.savingWeights"),
        autoHide: false,
        persist: true
      });
      this.collection.setWeight(variant, weight, function() {
        savingAlert.hide();
        AlertView.showAlert({
          message: $.i18n.t("landingPage.savingWeightSuccess")
        });
      }, function(){
        savingAlert.hide();
        AlertView.showAlert({
          message: $.i18n.t("landingPage.savingWeightError"),
          alertType: "danger"
        });
      });
    },

    setRedirectToAMP: function (e) {
      var $checkElement = $(e.currentTarget),
        $spinner = $checkElement.siblings('.inline-spinner-load'),
        redirectToAMP = $checkElement.prop('checked') ? $checkElement.val() : 'none',
        callback = function() {
          $spinner.show();
        };

      this.updateRedirectToAMPConfig(redirectToAMP, callback);
    }
  };

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/variant_list"),
    itemContainer: ".js-item-container",
    className: "ed-box-item ed-box-item-variant",
    itemView: VariantLine,

    events: {
      "click .js-redirect-to-amp": "setRedirectToAMP"
    },

    helpers: function () {
      var isMain = this.options.filter.is_main,
        templateParams = {
          AMPDetected: false,
          enableAMPConfig: false,
          isMain: isMain,
          items: []
        };

      if (isMain) {
        var models = this.filteredModels(),
          updateNeeded = true,
          platforms = models.map(function(model) { return model.get('platform'); });

        if (platforms.includes('amp')) {
          templateParams.AMPDetected = true;
          templateParams.currentRedirectAMPConfig = this.options.page.get('redirect_to_amp');

          // We have only the AMP platform
          if (platforms.length === 1) {
            templateParams.redirectAMPNotice = $.i18n.t('landingPage.ampRedirect.allTraffic');
            templateParams.redirectToAMPConfig = 'all';
          }

          // We have all platforms
          else if (platforms.length === 3) {
            templateParams.redirectAMPNotice = $.i18n.t('landingPage.ampRedirect.redirectToAMP');
            templateParams.redirectToAMPConfig = 'mobile';
            templateParams.enableAMPConfig = true;

            if (templateParams.currentRedirectAMPConfig === 'none') {
              updateNeeded = false;
            }
          }

          // We have the AMP and Desktop platforms
          else if (platforms.includes('desktop')) {
            templateParams.redirectAMPNotice = $.i18n.t('landingPage.ampRedirect.allMobileTraffic');
            templateParams.redirectToAMPConfig = 'mobile';
          }

          // We have the AMP and Mobile platforms
          else if (platforms.includes('mobile')) {
            templateParams.redirectAMPNotice = $.i18n.t('landingPage.ampRedirect.onlyURLRedirect');
            templateParams.redirectToAMPConfig = 'none';
          }

          updateNeeded && this.updateRedirectToAMPConfig(templateParams.redirectToAMPConfig);
        }
      }

      return templateParams;
    },

    updateRedirectToAMPConfig: function (configValue, cb) {
      this.options.page.setRedirectToAMPConfig(configValue, cb);
    },

    initialize: function(options) {
      this.viewModel = new Backbone.Model({
        page: options.page,
        filter: options.filter,
        title: options.title
      });

      this.listenTo(this.collection, "add", this.listenToModel);
      this.listenTo(this.collection, "remove", this.stopListeningToModel);
      this.childVent.on("duplicate", this.duplicateVariant, this);
      this.childVent.on("discard", this.discardVariant, this);
      this.childVent.on("reactivate", this.reactivateVariant, this);
      this.childVent.on("weight:set", this.setWeight, this);
    },

    addChildView: function(model) {
      if (_.contains(this.filteredModels(), model)) {
        return module.exports.__super__.addChildView.apply(this, arguments);
      }
    },

    listenToModel: function(model) {
      this.listenTo(model, "change:is_main change:active", function() {
        this.render();
      });
    },

    stopListeningToModel: function(model) {
      this.stopListening(model);
    },

    createItemView: function() {
      return _.extend(
        module.exports.__super__.createItemView.apply(this, arguments),
        {viewModel: this.viewModel}
      );
    },

    filteredModels: function(collection) {
      collection = collection || this.collection;
      return collection.where(this.viewModel.get("filter"));
    },

    collectionIterator: function(collection, fn, ctx) {
      return _.each(this.filteredModels(collection), fn, ctx);
    }
  });

  util.mixin(module.exports, Controller);

});

